import { z } from 'zod';
import { AreaValueSchema, PercentageSchema } from './measurements';
import { MonetaryValueSchema } from './money';
export const ValueWithTrendSchema = (valueSchema) => z.object({
    value: valueSchema,
    trend: z.number().optional(),
});
export const MonetaryValueWithTrendSchema = ValueWithTrendSchema(MonetaryValueSchema);
export const AreaValueWithTrendSchema = ValueWithTrendSchema(AreaValueSchema);
export const IntValueWithTrendSchema = ValueWithTrendSchema(z.number());
export const PercentageValueWithTrendSchema = ValueWithTrendSchema(PercentageSchema);
export { IntValueWithTrendSchema as NumberValueWithTrendSchema, PercentageValueWithTrendSchema as PercentageWithTrendSchema };
